/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IObrienBackgroundVideoViewProps } from './obrien-background-video';

import { useRef, useEffect } from "react";
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

//@ts-ignore
//import YoutubeBackground from 'react-youtube-background';

// import * as yourModuleName from 'module-name';
const YoutubeBackground = require('react-youtube-background').default;

export default (props: IObrienBackgroundVideoViewProps) => {

    let animateThis1 = useRef(null);

    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        gsap.to( animateThis1, {
            scrollTrigger: {
                trigger: '.single-header-2020', 
                start: "top top",
                scrub: 1,
            },
            duration: 2,
            x: '0',
            y: '160',
            ease: "linear",
        })
        
    }, [])

    const { 
        videoId,
        overlay,
        className,
        title,
        headingImage

    } = props;

    return (
        <div 
            className='bgvideo'
            ref={el => {
                //@ts-ignore
                animateThis1 = el}}
        >
            <div className='cn-title text-center flex-vertical'>
                <div>
                    <div className='headingImage'>{headingImage}</div>
                    <div>{title}</div>
                </div>
            </div>
            <YoutubeBackground
                videoId={videoId}
                overlay={overlay}
                className={className}
            ></YoutubeBackground>
        </div>
    );
};
